__turbopack_context__.v({
  "card_outer": "styles-module-scss-module__5FuK_G__card_outer",
  "search": "styles-module-scss-module__5FuK_G__search",
  "search_bar": "styles-module-scss-module__5FuK_G__search_bar",
  "spinner": "styles-module-scss-module__5FuK_G__spinner",
  "state_sort": "styles-module-scss-module__5FuK_G__state_sort",
  "type_sort": "styles-module-scss-module__5FuK_G__type_sort",
  "zero_state": "styles-module-scss-module__5FuK_G__zero_state",
});
